import React from "react";
import { Container } from "reactstrap";
import Content from "./Content";
import { APP_NAME_SHORT } from "common/constants";
import { useParams } from "react-router-dom";
import BreadCrumb from "Components/Common/BreadCrumb";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const ViewContractor = () => {
  const location = useLocation();
  document.title = `View Contractor | ${APP_NAME_SHORT}`;

  const { id: contractorId } = useParams();
  usePageActivity(location.pathname, "View Contractor", contractorId || null);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Contractor Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "Contractors", link: "/contractors" },
            ]}
            back
          />

          <Content contractorId={contractorId || ""} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewContractor;
